import { Processes as ProcessType, StepName, StepNames } from '../design-system/types';

import {
    NEW_REQUEST_STEP,
    DISCOVERY_STEP,
    QUOTE_CREATION_STEP,
    CONSTRUCTION_STEP,
    QUOTE_VALIDATED_STEP,
    POSTPONED_STEP,
    PAYMENT_CONFIRMED_STEP,
    DEFERRED_TRIP_STEP,
    TRIP_PREPARATION_STEP,
    TRAVELLING_STEP,
    TRIP_HAS_ENDED_STEP,
    CLOSED_STEP,
    CANCELLED_STEP,
    LOST_STEP,
} from './step';

export const SALES_PROCESS = 'sales' as const;
export const OPERATION_PROCESS = 'operation' as const;
export const ARCHIVE_PROCESS = 'archive' as const;

export const ProcessInArray: ProcessType[] = [SALES_PROCESS, OPERATION_PROCESS, ARCHIVE_PROCESS];

export const Processes: {
    [process in ProcessType]: StepNames;
} = {
    [SALES_PROCESS]: [
        NEW_REQUEST_STEP,
        DISCOVERY_STEP,
        QUOTE_CREATION_STEP,
        CONSTRUCTION_STEP,
        QUOTE_VALIDATED_STEP,
        POSTPONED_STEP,
    ],
    [OPERATION_PROCESS]: [
        PAYMENT_CONFIRMED_STEP,
        DEFERRED_TRIP_STEP,
        TRIP_PREPARATION_STEP,
        TRAVELLING_STEP,
        TRIP_HAS_ENDED_STEP,
    ],
    [ARCHIVE_PROCESS]: [CLOSED_STEP, CANCELLED_STEP, LOST_STEP],
};

export const getProcessFromStepName = (stepName: StepName) => {
    return ProcessInArray.find((process) => Processes[process].includes(stepName)) as ProcessType;
};
